// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","easilBlue":"#3184fc","switch":"style_switch__og_Ks","slider":"style_slider___zRaA"};